module.exports = __webpack_public_path__ + "img/c1c53f4.svg";